export default __webpack_public_path__ + "static/media/Stainless-steel-square-coil.fd3eadd3.jpg";